import { autoTextSize } from "auto-text-size";
import jsPDF from "jspdf";
import "jspdf-autotable";
import constants from "../../../constants";
function ExportPdf() {
  let watermarkA4 =
    "data:image/png;base64,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";
  let watermarkA1 =
    "data:image/png;base64,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";
  let logo =
    "data:image/png;base64,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";
  let widthofPages = {
    a1_portrait: 594,
    a2_portrait: 420,
    a3_portrait: 297,
    a4_portrait: 210,
    a1_landscape: 841,
    a2_landscape: 594,
    a3_landscape: 420,
    a4_landscape: 297,
  };

  const getCol = (col) => {
    if (col == "name") {
      return "Name";
    } else if (col == "Name") {
      return "Name";
    } else if (col == "email") {
      return "Email address";
    } else if (col == "branch") {
      return "Branch";
    } else if (col == "college") {
      return "College";
    } else if (col == "percentage_selected_duration") {
      return "Selected_Range(%)";
    } else if (col == "percentage_total_duration") {
      return "Selected_Total(%)";
    } else if (col == "ranking") {
      return "Rank";
    } else if (col == "percentile") {
      return "Percentile";
    } else if (col == "totalPointsEarned") {
      return "totalPoints";
    } else {
      // Check if it contains underscore (table column format)
      let lastUnderscoreIndex = col.lastIndexOf('_');
      if (lastUnderscoreIndex > 0) {
        let beforeUnderScore = col.substring(0, lastUnderscoreIndex);
        return beforeUnderScore.substring(0, 8) + "...";
      }
      // If no underscore or other special format, return as-is
      return col;
    };
  };

  const getCol1 = (col) => {
    if (col == "name") {
      return "Name";
    } else if (col == "email") {
      return "Email address";
    } else if (col == "branch") {
      return "Branch";
    } else if (col == "college") {
      return "College";
    } else if (col == "percentage_selected_duration") {
      return "Selected_Range(%)";
    } else if (col == "percentage_total_duration") {
      return "Selected_Total(%)";
    } else if (col == "ranking") {
      return "Rank";
    } else if (col == "percentile") {
      return "Percentile";
    } else if (col == "totalPointsEarned") {
      return "totalPoints";
    } else {
      let lastUnderscoreIndex = col.lastIndexOf('_');
      return col.substring(0, lastUnderscoreIndex);
      // return col.substring(0, 8) + "..."
    };
  };

  const generatePDF = (
    data,
    orientation,
    Format,
    dashBoardname,
    widgetNameArray
  ) => {
    let orie =
      orientation[0] == constants.ORIENTATION.LANDSCAPE
        ? "landscape"
        : "portrait";

    let form = orientation[0] == constants.ORIENTATION.LANDSCAPE ? "a1" : "a4";
    form = form.toLowerCase();

    const doc = new jsPDF({
      unit: "mm",
      orientation: orie,
      format: form,
    });

    for (let k = 0; k < data.length; k++) {

      const tableData = [];
      tableData.push(Object.keys(data[k][0]));

      data[k].forEach((item) => {
        tableData.push(
          Object.entries(item)
            .filter(([key]) => key !== "id") // Exclude the specified property
            .map(([_, value]) => value)
        );
      });

      let widgetName = widgetNameArray[k];

      if (k > 0) {
        let ori =
          orientation[k] == constants.ORIENTATION.LANDSCAPE
            ? "landscape"
            : "portrait";
        let forr =
          orientation[k] == constants.ORIENTATION.LANDSCAPE ? "a1" : "a4";
        forr = forr.toLowerCase();
        doc.addPage(forr.toLowerCase(), ori);
      }

      let header1 = [];

      let header2 = [];

      let header3 = [];

      for (let l = 0; l < tableData[0].length; l++) {
        if (tableData[0][l] != "id") {
          header1.push(getCol(tableData[0][l]));
          header3.push(getCol1(tableData[0][l]));

        }
        header2.push(l + 1);
      }

      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
      const margins = { top: 40, bottom: 40, left: 40, right: 40 };

      // Calculate column width (minimum 100 pt)
      // const columnWidth = Math.max(100, (pageWidth - margins.left - margins.right) / header1.length);

      const xL = 15;
      const yt = 22;
      const yT = 12;
      // doc.setFontSize(20);
      doc.setFont("helvetica", "Normal");
      if (k == 0) {
        doc.setFontSize(20);
        doc.text(widgetName, xL, yt);
      } else {
        doc.setFontSize(25);
        doc.text(widgetName, xL, yT);
      }

      doc.autoTable({
        head: [header1, header2],
        body: tableData.slice(1),
        startY: k > 0 ? 30 : undefined,
        columnStyles: {
          overflow: "linebreak",
        },

        margin: { top: 30 },
        didParseCell: function (data) {
          if (data.section === "head") {
            data.cell.styles.fillColor = "#f55533";
          }
        },
        didDrawPage: function () {
          const imageWidth = 710 / 14;
          const imageHeight = 184 / 14;
          const imageX = 20;
          const imageY = 5;
          doc.addImage(
            logo,
            "PNG",
            doc.internal.pageSize.width - imageX - imageWidth,
            imageY,
            imageWidth,
            imageHeight
          );




          // const watermarkWidthPercentage = Format[k] === "a1" ? 0.8 : 0.5;
          // const watermarkHeightPercentage = Format[k] === "a1" ? 0.8 : 0.5;

          // const pageWidth =
          //   Format[k] === "a1"
          //     ? doc.internal.pageSize.getWidth()
          //     : doc.internal.pageSize.getHeight();
          // const pageHeight =
          //   Format[k] === "a1"
          //     ? doc.internal.pageSize.getHeight()
          //     : doc.internal.pageSize.getWidth();

          // const watermarkWidth = pageWidth * watermarkWidthPercentage;
          // const watermarkHeight = pageHeight * watermarkHeightPercentage;

          let wmWidth = Format[k] === "a1" ? 59 : 27;

          let wmHeight = Format[k] === "a1" ? 59 : 27;

          const centerX_A1 = (doc.internal.pageSize.getWidth() - wmWidth) / 2;
          const centerY_A1 = (doc.internal.pageSize.getHeight() - wmHeight) / 2;

          const centerX_A4 = (doc.internal.pageSize.getWidth() - wmWidth) / 2;
          const centerY_A4 = (doc.internal.pageSize.getHeight() - wmHeight) / 2;

          const centerX = Format[k] === "a1" ? centerX_A1 : centerX_A4;
          const centerY = Format[k] === "a1" ? centerY_A1 : centerY_A4;

          let watermark = Format[k] === "a1" ? watermarkA1 : watermarkA4;

          doc.addImage(
            watermark,
            "SVG",
            centerX,
            centerY,
            wmWidth,
            wmHeight,
            undefined,
            "NONE"
          );
        },
      });

      // if (doc.internal.getCurrentPageInfo().pageNumber === 1) {
      //   const xLeft = 15;
      //   const ytop = 12;
      //   doc.setFontSize(25);
      //   doc.text(dashBoardname, xLeft, ytop);
      //   const yt = 22;
      //   doc.setFontSize(20);
      //   doc.text(widgetName, xLeft, yt);
      // } else {
      //   const xL = 15;
      //   const ytp = 14;
      //   doc.setFontSize(25);
      //   doc.text(widgetName, xL, ytp);
      // }

      // doc.addPage();

      // // Set up for the reference page
      // doc.setFontSize(16);
      // doc.text("Column Reference", 20, 20);

      // const imageWidth = 710 / 10;
      // const imageHeight = 184 / 10;
      // const imageX = 20;
      // const imageY = 5;
      // doc.addImage(
      //   logo,
      //   "PNG",
      //   doc.internal.pageSize.width - imageX - imageWidth,
      //   imageY,
      //   imageWidth,
      //   imageHeight
      // );

      // doc.setFont("helvetica", "normal");
      // doc.setFontSize(12);

      // // Add the column references
      // header1.forEach((header, index) => {
      //   doc.text(`Column ${index + 1} -> ${header}`, 20, 40 + index * 10);
      // });

      doc.addPage();

      const xLeft = 15;
      const ytop = 14;
      doc.setFontSize(25);
      doc.text(widgetName, xLeft, ytop);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);

      doc.text("Column Reference", 15, 30);
      const imageWidth = 710 / 14;
      const imageHeight = 184 / 14;
      const imageX = 20;
      const imageY = 5;
      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.width - imageX - imageWidth,
        imageY,
        imageWidth,
        imageHeight
      );
      doc.setFont("helvetica", "normal");
      doc.setFontSize(16);
      const margin = 20;
      const lineHeight = 15;
      const columnWidth = 300;
      let currentX = margin;
      let currentY = 45;
      const maxY = pageHeight - margin;


      header3.forEach((header, index) => {
        const text = `Column ${index + 1} -> ${header.replace('\\n', '')}`;
        // Check if we need to move to the next column
        if (currentY + lineHeight > maxY) {
          currentY = 45;
          currentX += columnWidth;

          // Check if we've run out of horizontal space
          if (currentX + columnWidth > pageWidth - margin) {
            doc.addPage();
            currentX = margin;
            currentY = 45;
            doc.setFont("helvetica", "bold");
            doc.setFontSize(16);
            doc.text("Column Reference (Continued)", 20, 20);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(16);
          }
        }

        // Add the text, wrapping if necessary
        const textLines = doc.splitTextToSize(text, columnWidth - 10);
        doc.text(textLines, currentX, currentY);

        // Move to the next line
        currentY += lineHeight * textLines.length;


      });

      // widget name logic
      // let currentWidgetpages = doc.internal.getNumberOfPages() - totalPageCount;
      // pagesArray.push(currentWidgetpages);
      // totalPageCount += doc.internal.getNumberOfPages();

      let totalPages = doc.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFont("helvetica", "Normal");

        if (i == 1) {
          const xLeft = 15;
          const ytop = 12;

          doc.setFontSize(25);
          doc.text(dashBoardname, xLeft, ytop);

          // const yt = 22;
          // doc.setFontSize(20);
          // doc.text(widgetName, xLeft, yt);
        }
        // else {
        //   const xL= 15;
        //   const ytp = 14;

        //   doc.setFontSize(25);
        //   doc.text(widgetName, xL, ytp);
        // }

        const pageNumberString = "Page " + i;
        const currentDate = new Date().toLocaleDateString("en-US");
        const leftText = "Confidential - Gradious Technologies (P) Ltd.";
        const dateX = doc.internal.pageSize.width / 2 + 10;

        // Set footer content
        doc.setFontSize(10);
        doc.text(leftText, 15, doc.internal.pageSize.height - 5, {
          align: "left",
        });

        doc.text(
          pageNumberString,
          doc.internal.pageSize.width - 15,
          doc.internal.pageSize.height - 5,
          { align: "right" }
        );
        doc.text(currentDate, dateX, doc.internal.pageSize.height - 5, {
          align: "center",
        });
      }
    }

    // Set header and footer content for each page

    // let totalPages = doc.internal.getNumberOfPages();
    // totalPageCount += totalPages;

    // let widC =0;

    // let pageC=0;

    //  while(widC<pagesArray.length){

    //   widC++;

    // }

    doc.save(`${dashBoardname}.pdf`);
  };

  const renderDataToPDF = (data, orientation, Format, dashBoardname) => {
    const pageWidthPortrait = 210;
    const pageWidthLandscape = 297;
    const margin = 20;
    const header = Object.keys(data[0]).filter((i) => i !== "id");
    let header1 = [];

    // Transform headers using getCol function
    for (let l = 0; l < header.length; l++) {
      if (header[l] !== "id") {
        header1.push(getCol(header[l]));
      }
    }

    const columnWidthtotal =
      orientation === "landscape"
        ? pageWidthLandscape - 2 * margin
        : pageWidthPortrait - 2 * margin;

    let columnWidth = columnWidthtotal / header.length;
    const doc = new jsPDF({
      orientation: orientation,
      unit: "mm",
      format: Format,
    });
    const tableData = [];
    data.forEach((obj) => {
      const row = [];
      header.forEach((key) => {
        row.push(String(obj[key] ?? ""));
      });
      tableData.push(row);
    });

    const shortHeaders = header1.map(h =>
      h.length > 15 ? h.substring(0, 15) + "..." : h
    );
    doc.autoTable({
      head: [header1],
      body: tableData,
      startY: margin,
      margin: { top: margin },
      styles: { overflow: "linebreak" },

      columnStyles: { overflow: "linebreak", width: `${columnWidth}` },
      didParseCell: function (data) {
        if (data.section === "head") {
          data.cell.styles.fillColor = "#f55533";
        }
      },
      didDrawPage: function () {
        const imageWidth = 50;
        const imageHeight = 10;
        const imageX = margin;
        const imageY = 5;
        doc.addImage(
          logo,
          "PNG",
          doc.internal.pageSize.width - imageX - imageWidth,
          imageY,
          imageWidth,
          imageHeight
        );
      },
    });
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);

      const xLeft = 15;
      const y = 12;
      doc.setFontSize(25);
      doc.text(`${dashBoardname}`, xLeft, y);
      doc.setFontSize(10);
      const pageNumberString = "Page " + i;
      const currentDate = new Date().toLocaleDateString("en-US");
      const leftText = "Confidential - Gradious Technologies (P) Ltd.";

      const dateWidth =
        (doc.getStringUnitWidth(currentDate) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      const dateX = (doc.internal.pageSize.width - dateWidth) / 2;

      doc.text(leftText, 15, doc.internal.pageSize.height - 5, {
        align: "left",
      });

      doc.text(
        pageNumberString,
        doc.internal.pageSize.width - 15,
        doc.internal.pageSize.height - 5,
        { align: "right" }
      );
      doc.text(currentDate, dateX, doc.internal.pageSize.height - 5, {
        align: "center",
      });

      const watermarkWidthPercentage = Format === "a1" ? 0.8 : 0.5;
      const watermarkHeightPercentage = Format === "a1" ? 0.8 : 0.5;

      let wmWidth = Format === "a1" ? 59 : 27;

      let wmHeight = Format === "a1" ? 59 : 27;

      const pageWidth =
        Format === "a1"
          ? doc.internal.pageSize.getWidth()
          : doc.internal.pageSize.getHeight();
      const pageHeight =
        Format === "a1"
          ? doc.internal.pageSize.getHeight()
          : doc.internal.pageSize.getWidth();

      const watermarkWidth = pageWidth * watermarkWidthPercentage;
      const watermarkHeight = pageHeight * watermarkHeightPercentage;

      const centerX_A1 = (doc.internal.pageSize.getWidth() - wmWidth) / 2;
      const centerY_A1 = (doc.internal.pageSize.getHeight() - wmHeight) / 2;

      const centerX_A4 = (doc.internal.pageSize.getWidth() - wmWidth) / 2;
      const centerY_A4 = (doc.internal.pageSize.getHeight() - wmHeight) / 2;

      const centerX = Format === "a1" ? centerX_A1 : centerX_A4;
      const centerY = Format === "a1" ? centerY_A1 : centerY_A4;

      let watermark = Format === "a1" ? watermarkA1 : watermarkA4;

      doc.addImage(watermark, "SVG", centerX, centerY, wmWidth, wmHeight);
    }
    doc.save(`${dashBoardname}.pdf`);
  };

  return {
    generatePDF,
    renderDataToPDF,
  };
}

export default ExportPdf;
